import { urlUtility } from "@repo/utilities/url.utility.ts";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";

interface IBlockedAreasProps extends IGetServiceProps {
  policyId: string;
}

const useBlockedAreasService = ({
  page = "1",
  per_page = "15",
  policyId,
}: IBlockedAreasProps) => {
  //States
  const [filterState, setFilterState] = useState<string>("");
  //Hooks
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const pincode = urlQueries["pincode"] || "";
  const policyName = urlQueries["policy_name"] || "";
  // Services
  const getAllBlockedAreasService = useQuery({
    queryKey: [
      ...CACHE_KEYS.BLOCKED_LOCATIONS,
      policyId,
      created_between,
      filterState,
      pincode,
      policyName,
      page,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.BLOCKED_AREAS,
        searchParams: {
          "filter[blockable_type]": filterState,
          "filter[locationable.pincode]": pincode,
          "filter[blockable.name]": policyName,
          "filter[created_between]": created_between,
            include: "blockable,locationable",
          page: page,
          per_page: per_page,
        },
      }),
  });

  return {
    states: { filterState, setFilterState },
    service: { getAllBlockedAreasService },
  };
};

export { useBlockedAreasService };
